/**
 * Sincroniza market (BR ↔ US).
 *
 * Prioridade:
 * 1) ?market=us|br (escolha explícita)
 * 2) /en-us com cookie localization=BR → corrige para US (cookie sticky)
 * 3) GeoIP da Shopify → redireciona para o market do país detectado
 */
(function () {
  var LOCK_KEY = "ferrer_localization_locked";
  var CHECK_KEY = "ferrer_localization_checked";

  function rootPath() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  }

  function shopifyCountry() {
    return (window.Shopify && window.Shopify.country) || "";
  }

  function cookieLocalization() {
    var match = document.cookie.match(/(?:^|;\s*)localization=([A-Z]{2})/i);
    return match ? match[1].toUpperCase() : "";
  }

  function isUsPresence() {
    return window.location.pathname.indexOf("/en-us") === 0;
  }

  function isLocked() {
    try {
      return sessionStorage.getItem(LOCK_KEY) === "1";
    } catch (e) {
      return false;
    }
  }

  function lockChoice() {
    try {
      sessionStorage.setItem(LOCK_KEY, "1");
    } catch (e) {}
  }

  function markChecked() {
    try {
      sessionStorage.setItem(CHECK_KEY, "1");
    } catch (e) {}
  }

  function alreadyChecked() {
    try {
      return sessionStorage.getItem(CHECK_KEY) === "1";
    } catch (e) {
      return false;
    }
  }

  function updateLocalization(country, language, returnTo) {
    var form = document.createElement("form");
    form.method = "POST";
    form.action = "/localization";
    form.hidden = true;

    function add(name, value) {
      var input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      input.value = value;
      form.appendChild(input);
    }

    add("_method", "PUT");
    add("country_code", country);
    add("language_code", language);
    add("return_to", returnTo);

    document.body.appendChild(form);
    form.submit();
  }

  /**
   * O cookie localization=BR dura 1 ano e sobrescreve o GeoIP.
   * Se o usuário já está em /en-us mas o cookie continua BR, força US.
   */
  function fixStickyBrazilCookieOnUsUrl() {
    if (!isUsPresence()) return false;

    var cookie = cookieLocalization();
    var country = shopifyCountry();

    if (cookie === "BR" || country === "BR" || country !== "US") {
      updateLocalization("US", "en", "/en-us");
      return true;
    }
    return false;
  }

  function applyGeo(detectedHandle) {
    if (!detectedHandle || isLocked()) {
      markChecked();
      return;
    }

    var onUs = isUsPresence();
    var cookie = cookieLocalization();
    var country = shopifyCountry();

    if (detectedHandle === "US") {
      if (!onUs || cookie !== "US" || country !== "US") {
        markChecked();
        updateLocalization("US", "en", "/en-us");
        return;
      }
    }

    if (detectedHandle === "BR") {
      if (onUs || cookie !== "BR" || country !== "BR") {
        markChecked();
        updateLocalization("BR", "pt-BR", "/");
        return;
      }
    }

    markChecked();
  }

  function runGeoCheck() {
    if (isLocked()) return;
    if (alreadyChecked() && cookieLocalization() === shopifyCountry()) return;

    var url =
      rootPath().replace(/\/?$/, "/") +
      "browsing_context_suggestions.json?country[enabled]=true";

    fetch(url, { credentials: "same-origin" })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        var detected =
          (data &&
            data.detected_values &&
            data.detected_values.country &&
            data.detected_values.country.handle) ||
          null;
        applyGeo(detected);
      })
      .catch(function () {
        markChecked();
      });
  }

  function handleForcedMarket() {
    var params = new URLSearchParams(window.location.search);
    var forced = (params.get("market") || "").toLowerCase();
    if (!forced) return false;

    if (forced === "us") {
      lockChoice();
      updateLocalization("US", "en", "/en-us");
      return true;
    }
    if (forced === "br") {
      lockChoice();
      updateLocalization("BR", "pt-BR", "/");
      return true;
    }
    return false;
  }

  document.addEventListener("DOMContentLoaded", function () {
    if (handleForcedMarket()) return;
    if (fixStickyBrazilCookieOnUsUrl()) return;
    runGeoCheck();
  });
})();
